export class UtilityConstants {
  static readonly MILLISECONDS_IN_SECOND = 1000;
  static readonly SECONDS_IN_MINUTE = 60;
  static readonly MINUTES_IN_DAY = 1440;
  static readonly MINUTES_IN_31_DAY_MONTH = UtilityConstants.MINUTES_IN_DAY * 31;
  static readonly MINUTES_IN_YEAR = 525600;
  static readonly HOURS_IN_DAY = 24;
  static readonly HOURS_IN_YEAR = 8760;
  static readonly DAYS_IN_MONTHS = new Map([[31, 1], [62, 2], [93, 3], [124, 4], [155, 5], [186, 6], [217, 7], [248, 8],
    [279, 9], [310, 10], [341, 11], [365, 12]]);
}

export const sessionTokenKey = "_xypz";
export const userIdKey = "_yhzjh";
export const KEEP_RETURN_URL_ON_START_UP = "kruos";

export const APP_WEBVIEW_PHONE_PARAMETER = "awvp";
export const APP_WEBVIEW_MASKED_EMAIL = "awvme";
export const APP_WEBVIEW_HIDE_SHARE_APP_OPTION = "hsao";
export const APP_WEBVIEW_APP_VERSION = "awvav";
export const IS_IN_WEBVIEW_KEY = "inAppWebview";
export const SIGNUP_SUCCESS_OLD_APP_SUPPORT_PARAMETER_KEY = "ssoas";

export const GUEST_PARKING_ZONE_NAME_PARAMETER = "z";
export const GUEST_PARKING_URL = "guestparking";

// Note: If some of these regexes are updated here, they should also be updated in the backend constants and vice versa
export const UsernamePattern = "^[a-zA-Z0-9_.*£&$%&!£@#^()<>{}\\/'+[\\])]+$";
export const PayStay_MobileNumber_Regex = /(?:^(614)\d{8}$|^(04)\d{8}$)/g;
export const ATPARK_MobileNumber_Regex = /(?:^(642)\d{7,9}$|^(02)\d{7,9}$)/g;
export const First_Name_Regex = /^[a-zA-Z0-9'@#$&*+\\-_,+:?.,!\\s\\/ ]*$/;
export const Vehicle_Regex = /^[a-zA-Z0-9]{0,20}$/;
export const Alphanumeric_Regex = /^[a-zA-Z0-9 \-\/&\+@.,\?]*$/;
export const Email_Regex = /^[a-zA-Z0-9_\+\-'!$#%&*=\/?^{}\\|~]+(\.[a-zA-Z0-9_\+\-'!$#%&*=\/?^{}\|~]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]+)$/;

export const INTEGER_32_MAX = Math.pow(2,31) - 1;

export const idmOidcProviderClaimKey = "Ext_provider";

export const SHOW_HEADER_BAR: string = "showHeaderBar";
export const SHOW_HEADER_BAR_KEY = "showHeaderBar";
export const SHOW_HEADER_KEY = "showHeader";
export const SHOW_DOWNLOAD_PAYSTAY_KEY = "showDownloadPayStayBar";
export const SHOW_PAYSTAY_FOOTER_KEY = "showPayStayFooterBar";
export const SHOW_ANDROID_SMART_BANNER = "showAndroidSmartBanner";

export const ZONE_NAME_URL_PARAM = "zoneName";
export const METER_ID_URL_PARAM = "meterId";
export const INITIALISATION_TYPE_URL_PARAM = "initialisationType";

export const CLIENT_IDENTIFIER_PARAMETER_KEY = "client";
export const CLIENT_IDENTIFIER_LOCAL_STORAGE_KEY = "C_Identifier";



export const FireBaseEvents = {
  GUEST_PARKING_ZONE_INPUT: "guest_parking_zone_input",
  GUEST_PARKING_QR_LANDING: "guest_parking_qr_landing",
  GUEST_PARKING_MOBILE_ALREADY_EXISTS: "guest_parking_mobile_already_exists",
  GUEST_PARKING_PAYMENT_LANDING: "guest_parking_payment_landing",
  GUEST_PARKING_START_TICKET: "guest_parking_start_ticket"
}
